import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Maria Andersson",
      role: "Homeowner",
      rating: 5,
      content: "Absolutely fantastic service! The team moved my entire 3-bedroom apartment efficiently and carefully. Nothing was damaged, and they even helped with furniture assembly. Highly recommend!",
      service: "Moving Service",
      location: "Helsinki Central"
    },
    {
      name: "Jukka Virtanen",
      role: "Yrittäjä",
      rating: 5,
      content: "Olemme käyttäneet heidän toimistosiivousta jo 6 kuukautta. Aina täsmällisiä, huolellisia ja ammattimaisia. Toimistomme ei ole koskaan näyttänyt näin hyvältä!",
      service: "Cleaning Service",
      location: "Kamppi"
    },
    {
      name: "Emma Johnson",
      role: "Apartment Renter",
      rating: 5,
      content: "The handyman service was exceptional. Fixed multiple issues, mounted my TV perfectly, and even gave maintenance tips. Will definitely use again!",
      service: "Handyman Service",
      location: "Kallio"
    },
    {
      name: "Mikael Lindqvist",
      role: "Kiinteistönhoitaja",
      rating: 5,
      content: "Käytämme ServiceHelsinkiä kaikkiin kiinteistönhoitotarpeisiimme. Ammattitaitoisia, luotettavia ja läpinäkyvä hinnoittelu. He hoitavat kaiken siivouksesta korjauksiin.",
      service: "Combined Services",
      location: "Töölö"
    },
    {
      name: "Anna Korhonen",
      role: "Muuttaja",
      rating: 5,
      content: "Muuttosiivous oli moitteetonta! Sain koko takuuvuokrani takaisin heidän huolellisen työnsä ansiosta. Tiimi oli ystävällistä ja sai kaiken valmiiksi odotettua nopeammin!",
      service: "Move-out Cleaning",
      location: "Punavuori"
    },
    {
      name: "Thomas Weber",
      role: "Homeowner",
      rating: 5,
      content: "IKEA furniture assembly service saved me hours of frustration. They assembled everything perfectly and even disposed of the packaging. Worth every euro!",
      service: "Assembly Service",
      location: "Espoo"
    }
  ];

  return (
    <section className="py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            What Our Customers Say
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Over 500 satisfied customers trust us with their moving, cleaning, and repair needs. 
            Read their stories and see why we're Helsinki's preferred service provider.
          </p>
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {[
            { number: "500+", label: "Happy Customers" },
            { number: "98%", label: "Satisfaction Rate" },
            { number: "24/7", label: "Support Available" },
            { number: "10+", label: "Years Experience" }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent mb-2">{stat.number}</div>
              <div className="text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="shadow-lg hover:shadow-xl transition-smooth bg-card border-0">
              <CardContent className="p-6">
                {/* Quote icon */}
                <Quote className="h-8 w-8 text-accent mb-4 opacity-50" />
                
                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star key={i} className="h-4 w-4 text-accent fill-accent" />
                  ))}
                </div>

                {/* Content */}
                <p className="text-muted-foreground mb-6 italic">
                  "{testimonial.content}"
                </p>

                {/* Customer info */}
                <div className="border-t pt-4">
                  <div className="font-semibold text-foreground">{testimonial.name}</div>
                  <div className="text-sm text-muted-foreground">{testimonial.role}</div>
                  <div className="text-sm text-accent font-medium mt-1">{testimonial.service}</div>
                  <div className="text-xs text-muted-foreground">{testimonial.location}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust badges */}
        <div className="bg-card rounded-2xl p-8 shadow-lg text-center">
          <h3 className="text-2xl font-bold mb-6">Why Choose ServiceHelsinki?</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="space-y-2">
              <div className="w-12 h-12 bg-gradient-service rounded-full mx-auto flex items-center justify-center">
                <Star className="h-6 w-6 text-white" />
              </div>
              <h4 className="font-semibold">Quality Guaranteed</h4>
              <p className="text-sm text-muted-foreground">100% satisfaction guarantee on all services</p>
            </div>
            <div className="space-y-2">
              <div className="w-12 h-12 bg-gradient-service rounded-full mx-auto flex items-center justify-center">
                <Star className="h-6 w-6 text-white" />
              </div>
              <h4 className="font-semibold">Fully Insured</h4>
              <p className="text-sm text-muted-foreground">Complete insurance coverage for your peace of mind</p>
            </div>
            <div className="space-y-2">
              <div className="w-12 h-12 bg-gradient-service rounded-full mx-auto flex items-center justify-center">
                <Star className="h-6 w-6 text-white" />
              </div>
              <h4 className="font-semibold">Local Experts</h4>
              <p className="text-sm text-muted-foreground">10+ years serving the Helsinki community</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;